module.exports = __webpack_public_path__ + "static/img/zw.ca6c3ff3.png";